/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronic.de | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
$(document).ready(function () {
    window.theme = window.theme || {};
    window.notFirstLoad = false;
    function deskKeepGalleryIndex() {
      return $(".mySwiper2").attr("data-gallery-keep-index") === "true";
    }

    function deskIs3dVisible() {
      if ($(".product-3d-window").hasClass("open")) return true;
      if (window.mmqShowed !== true) return false;
      return !deskKeepGalleryIndex() || (window.pdpGalleryIndex || 0) === 0;
    }


    function updateSizeNotice(variantId) {
      var notice = $('.pp_variant_config[data-id="' + variantId + '"]').attr('data-notice') || '';
      var $activeSizeBtn = $('.pp_selection_size_btn.pp_var_select__js.active').first();
      var $sizeContainer = $activeSizeBtn.closest('.pp_size');
      if (!$sizeContainer.length) return;

      var $notice = $sizeContainer.next('.pp_size_notice');

      if (notice.trim() !== '') {
        if (!$notice.length) {
          $notice = $('<div class="pp_size_notice"></div>');
          $sizeContainer.after($notice);
        }
        $notice.html(notice);
        $notice.show();
      } else if ($notice.length) {
        $notice.hide();
      }
    }

    (function showInitialNotice() {
      var notice = $('.pp_initial_notice_data').attr('data-notice') || '';
      if (notice.trim() === '') return;

      var $activeSizeBtn = $('.pp_selection_size_btn.pp_var_select__js.active').first();
      var $sizeContainer = $activeSizeBtn.closest('.pp_size');
      if (!$sizeContainer.length) return;

      var $notice = $sizeContainer.next('.pp_size_notice');
      if (!$notice.length) {
        $notice = $('<div class="pp_size_notice"></div>');
        $sizeContainer.after($notice);
      }
      $notice.html(notice);
      $notice.show();
    })();

    $(".pp_selection_color_btn").mouseover(function () {
      $(this).addClass("hovered");
    });
  
    $(".pp_selection_color_btn").mouseleave(function () {
      $(".pp_selection_color_btn").removeClass("hovered");
    });
  
    $(".pp_selection_color_btn").click(function () {
      if (window.mmqLoaded && deskIs3dVisible()) {
        window.setPreload();
        setTimeout(function () {
          window.removePreloads();
        }, 1000);
      }

      $(".oos-limit-reached_box.pdp").addClass("hided");
      $(this)
        .closest(".pp_opt_color")
        .find(".pp_selection_color_btn")
        .removeClass("active");
      $(this).addClass("active");
  
      var isCharity = false;
      if (
        $(".pp_opt_color_options_2 .pp_var_select__js.active").attr(
          "data-charity",
        ) == "true"
      ) {
        isCharity = true;
      }
  
      var selectedOption = $(this).attr("data-option-title");
  
      $(this)
        .closest(".pp_opt_color")
        .find(".charity-label__js")
        .each(function () {
          $(this).find("span").html(selectedOption);
        });
  
      var charityLabel = $(".pp_variants").attr("data-charity-label");
  
      $(this)
        .closest(".pp_opt_color")
        .find(".pp_variant_label_variant")
        .html(selectedOption);
  
      getVariant();
  
      var mmqBlock = $(this).attr("data-mmq-block");
      var mmqCode = $(this).attr("data-mmq-code");
  
      console.log(mmqBlock, mmqCode);
  
      if (window.mmqLoaded) {
        window.mimeeqApp.actions.markOptionByBlockNameAndOptionCode(
          mmqBlock,
          mmqCode,
        );
      }
    });
  
    $(".pp_selection_size_btn").click(function () {
      if (window.mmqLoaded && deskIs3dVisible()) {
        window.setPreload();
        setTimeout(function () {
          window.removePreloads();
        }, 1000);
      }

      $(".oos-limit-reached_box.pdp").addClass("hided");
      $(this)
        .closest(".pp_opt_color")
        .find(".pp_selection_size_btn")
        .removeClass("active");
      $(this).addClass("active");
      getVariant();
  
      var selectedOption = $(this).attr("data-option-title");
      $(this)
        .closest(".pp_opt_color")
        .find(".pp_variant_label_variant")
        .html(selectedOption);
  
      var mmqBlock = $(this).attr("data-mmq-block");
      var mmqCode = $(this).attr("data-mmq-code");
  
      console.log(mmqBlock, mmqCode);
  
      if (window.mmqLoaded) {
        window.mimeeqApp.actions.markOptionByBlockNameAndOptionCode(
          mmqBlock,
          mmqCode,
        );
      }
  
      // For specifications
      var specOption = String($(this).attr("data-value")).replace("-cm", "");
      specOption = specOption.split("x");
      specOption = specOption[0];
      console.log(specOption, "SPEC OPTION IS");
      $('.product_tabletop-nav-btn[data="' + specOption + '"]').trigger("click");
    });
  
    window.firstloadYetActed = false;
  
    function updateRizerVisibility() {
      var $variants = $('.pp_variants');
      if ($variants.attr('data-rizer-enabled') !== 'true') return;

      var rizerLegs = $variants.attr('data-rizer-legs');
      var rizerLegsBlack = $variants.attr('data-rizer-legs-black');
      var rizerTop = $variants.attr('data-rizer-top');

      var selectedLegsTitle = $('.pp_var_select__js.active[data-option-name="' + rizerLegs + '"]').attr('data-option-title');

      var activeTopTitle = $('.pp_opt_color_options_2 .pp_var_select__js.active').attr('data-option-title');

      $('.pp_opt_color_options_2 .pp_var_select__js').each(function () {
        var btnTitle = $(this).attr('data-option-title');
        var shouldHide = (selectedLegsTitle === rizerLegsBlack && btnTitle === rizerTop) ||
                         (selectedLegsTitle === rizerTop && btnTitle === rizerLegsBlack);
        $(this).toggleClass('rizer-top-hidden', shouldHide);
      });

      var $activeTop = $('.pp_opt_color_options_2 .pp_var_select__js.active');
      if ($activeTop.hasClass('rizer-top-hidden')) {
        var $replacement = $('.pp_opt_color_options_2 .pp_var_select__js[data-option-title="' + selectedLegsTitle + '"]:not(.rizer-top-hidden)');
        if ($replacement.length) {
          $replacement.trigger('click');
        }
      }
    }

    function getVariant() {
      var variantTitle = "";
  
      $(".pp_var_select__js.active").each(function () {
        var currentTitle = $(this).attr("data-value");
        variantTitle += currentTitle + "-";
      });
  
      // Accessories included change on option1 color
      var $buttons = $(".pp_opt_color_options_1 .pp_var_select__js");
      var $active = $buttons.filter(".active");
      if ($active.length) {
        var index = $buttons.index($active) + 1;
        var $img1 = $(".included-accessories__image.option-1");
        var $img2 = $(".included-accessories__image.option-2");
        var imgs = [$img1, $img2];
        imgs.forEach(function ($img) {
          $img.addClass("hide");
        });
        if (index > imgs.length) {
          index = 1;
        }
        imgs[index - 1].removeClass("hide");
      }
  
      // Accessories included change on option1 color
      var $buttons = $(".pp_opt_color_options_1 .pp_var_select__js");
      var $active = $buttons.filter(".active");
      if ($active.length) {
        var index = $buttons.index($active) + 1;
        var $img1 = $(".included-accessories__image.option-1");
        var $img2 = $(".included-accessories__image.option-2");
        var imgs = [$img1, $img2];
        imgs.forEach(function ($img) {
          $img.addClass("hide");
        });
        if (index > imgs.length) {
          index = 1;
        }
        imgs[index - 1].removeClass("hide");
      }
  
      variantTitle = variantTitle.slice(0, -1);
  
      var $variantElement = $(
        '.pp_variant_config[data-title="' + variantTitle + '"]',
      );
      var variantId = $variantElement.attr("data-id");
  
      if (variantId) {
        updateURLParameter("variant", variantId);
      }
  
      if (typeof variantId != "undefined") {
        setVariant(variantId);
        setPrice(variantId);
        setStock(variantId);
        setAddons(variantId);
        updateSizeNotice(variantId);
        $(document).trigger('desk:variant-change', [variantId]);
        if (window.firstloadYetActed == true) {
          setGalleryFirst(variantId);
        } else {
          galleryRenderedKey = galleryCacheKey(variantId);
        }
        window.firstloadYetActed = true;
      }
  
      // For specifications
      var activeTabletopMode = $(".pp_opt_color_options_2")
        .find(".pp_var_select__js.active")
        .closest(".pp_sellection_color_block")
        .attr("data-type");
      if (activeTabletopMode == "premium") {
        $('.product_spec-tabletops-switcher-btn[data="premium"]').trigger(
          "click",
        );
      } else {
        $('.product_spec-tabletops-switcher-btn[data="classic"]').trigger(
          "click",
        );
      }
  
      setDeliveryMessage();
      updateRizerVisibility();
    }

    window.openOosPopup = function openOosPopup(variantId){
      $('.desk_oos-popup-outer').addClass('active').attr('data-id', variantId);
      $('.desk_oos-popup-inner').removeClass('submitedSuccess');
      window.lockScroll();
    }

    function closeOosPopup(){
      $('.desk_oos-popup-outer').removeClass('active');
      window.unlockScroll();
    }

    $('.desk_oos-popup-close').on('click', function () {
      closeOosPopup();
    });

    $('.desk_oos-popup-outer').on('click', function (event) {
      if ($(event.target).is('.desk_oos-popup-outer')) {
        closeOosPopup();
      }
    });

    $(document).on('keydown', function (event) {
      if (event.key === 'Escape') {
        closeOosPopup();
      }
    });

    function deskOosSetError($inputLine, type) {
      var $msg = $inputLine.find('.contact-error');
      if (type) {
        var text = type === 'email' ? $msg.attr('data-error-email') : $msg.attr('data-error-empty');
        if (text) $msg.text(text);
        $inputLine.addClass('invalid');
      } else {
        $inputLine.removeClass('invalid');
      }
    }

    $(document).on('click', '.pdp_oos-submit', function () {
      var $popup = $(this).closest('.desk_oos-popup-outer');
      var $inputLine = $popup.find('.form_input-line');
      var $input = $inputLine.find('input[type="email"]');
      var email = $input.val().trim();
      var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!email) {
        deskOosSetError($inputLine, 'empty');
        return;
      }
      if (!emailRegex.test(email)) {
        deskOosSetError($inputLine, 'email');
        return;
      }

      deskOosSetError($inputLine, null);
      var variantId = $popup.attr('data-id');
      window.notificationSubmit(email, variantId);
    });

    $(document).on('input', '.desk_oos-popup-outer .form_input-line input[type="email"]', function () {
      var $inputLine = $(this).closest('.form_input-line');
      var val = $(this).val().trim();
      var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (val !== '' && emailRegex.test(val)) {
        deskOosSetError($inputLine, null);
      }
    });

    $('.pp_var_select__js').click(function(){
      var getCurrentStock = 1;

      var variantTitle = "";
  
      $(".pp_var_select__js.active").each(function () {
        var currentTitle = $(this).attr("data-value");
        variantTitle += currentTitle + "-";
      });
  
      variantTitle = variantTitle.slice(0, -1);
  
      var $variantElement = $(
        '.pp_variant_config[data-title="' + variantTitle + '"]',
      );

      var variantId = $variantElement.attr("data-id");

      getCurrentStock = $variantElement.attr("data-stock");

      console.log(getCurrentStock, 'CURRENT STOCK ON CLICK');

      var currentStockNum = parseFloat(getCurrentStock);

      if (!isNaN(currentStockNum) && currentStockNum <= 0){
        openOosPopup(variantId);
        $('.desk_atc-main-button').addClass('desk_atc-soldout');
      }
      else{
        $('.desk_atc-main-button').removeClass('desk_atc-soldout');
      }

    });

    function setDeliveryMessage() {
      var neededOption = $(".delivery_messageData").attr("data-option");
      var customMessagesExists = false;
  
      $("[is-atc-date_specific]").each(function () {
        if ($(this).attr("data-option") == neededOption) {
          customMessagesExists = true;
        }
      });
  
      if (customMessagesExists == true) {
      } else {
        $("[is-atc-date_specific]").addClass("hided");
        $("[is-atc-date]").removeClass("hided");
      }
      $(".pp_var_select__js.active").each(function () {
        if ($(this).attr("data-option-name") == neededOption) {
          var currentVal = $(this).attr("data-option-title");
          $(".product-single__shipping-date").addClass("hided");
  
          var $target = $(
            '.product-single__shipping-date[data-color="' + currentVal + '"]',
          );
  
          if ($target.length) {
            $target.removeClass("hided");
          } else {
            $("[is-atc-date]").removeClass("hided");
          }
        }
      });
    }
  
    var galleryFilterToken = 0;
    var galleryRenderedKey = null;
    function deskGalleryTargetIndex() {
      return deskKeepGalleryIndex() ? window.pdpGalleryIndex || 0 : 0;
    }

    function afterNextPaint(callback) {
      if (typeof window.requestAnimationFrame !== "function") {
        setTimeout(callback, 0);
        return;
      }
      window.requestAnimationFrame(function () {
        setTimeout(callback, 0);
      });
    }

    function whenGalleryReady(parts, callback) {
      var targetIndex = deskGalleryTargetIndex();
      var img = document.getElementById("product-variant__src");
      var waitImage = !!img && !img.complete && targetIndex === 0;
      var slideReady = targetIndex > 0 ? preloadGallerySlide(parts, targetIndex) : null;
      var waitSlide = !!slideReady && !parts.slideDone[targetIndex];
      var waitThumbs = !!(parts && parts.thumbsReady && !parts.thumbsDone);

      if (!waitImage && !waitSlide && !waitThumbs) {
        callback();
        return;
      }

      var pending = (waitImage ? 1 : 0) + (waitSlide ? 1 : 0) + (waitThumbs ? 1 : 0);
      var settled = false;
      var timer = null;

      var finish = function () {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        if (img) {
          img.removeEventListener("load", imageDone);
          img.removeEventListener("error", imageDone);
        }
        callback();
      };

      var step = function () {
        pending -= 1;
        if (pending <= 0) finish();
      };

      var imageDone = function () {
        img.removeEventListener("load", imageDone);
        img.removeEventListener("error", imageDone);
        step();
      };

      timer = setTimeout(finish, 800);

      if (waitImage) {
        img.addEventListener("load", imageDone);
        img.addEventListener("error", imageDone);
      }
      if (waitSlide) slideReady.then(step);
      if (waitThumbs) parts.thumbsReady.then(step);
    }

    var deskGalleryImages = null;
    var galleryWarmed = {};
    var galleryPending = [];
    var gallerySwappedKey = null;

    function galleryImagesFor(key) {
      if (deskGalleryImages === null) {
        try {
          deskGalleryImages = JSON.parse($("#desk-gallery-images").text()) || {};
        } catch (err) {
          deskGalleryImages = {};
        }
      }
      var list = deskGalleryImages[key];
      return list && list.length ? list : null;
    }

    function galleryImageUrl(url, size) {
      return url.replace("_1200x.", "_" + size + ".");
    }

    function galleryImageSrcset(url) {
      return $.map([400, 600, 800, 1200], function (width) {
        return galleryImageUrl(url, width + "x") + " " + width + "w";
      }).join(", ");
    }

    function gallerySlideSizes() {
      return (
        $(".mySwiper2 img.img-cover").first().attr("sizes") ||
        "(max-width: 767px) 100vw, 58vw"
      );
    }

    function warmGalleryImage(src, srcset, priority, keep, hover) {
      var id = srcset || src;
      if (galleryWarmed[id]) return;
      galleryWarmed[id] = true;

      var img = new Image();
      img.decoding = "async";
      img.setAttribute("fetchpriority", priority);
      if (srcset) {
        img.sizes = gallerySlideSizes();
        img.srcset = srcset;
      }
      img.src = src;

      if (hover || (srcset && priority === "low")) {
        galleryPending.push({ id: id, img: img, hover: !!hover });
        img.onload = img.onerror = function () {
          galleryPending = $.grep(galleryPending, function (p) {
            return p.img !== img;
          });
        };
      }

      if (keep && typeof window.deskHoldImage === "function") {
        window.deskHoldImage(img);
        if (img.decode) img.decode().catch(function () {});
      }
    }

    function galleryKeyIds(key) {
      var ids = {};
      var item = galleryTargetItem(key);
      if (item) ids[galleryImageSrcset(item.u)] = true;
      $.each(galleryImagesFor(key) || [], function (i, entry) {
        ids[galleryImageUrl(entry.u, "100x")] = true;
      });
      return ids;
    }

    function cancelGalleryPending(keepKey, hoverOnly) {
      var keep = galleryKeyIds(keepKey);
      galleryPending = $.grep(galleryPending, function (p) {
        if (keep[p.id] || (hoverOnly && !p.hover)) return true;
        if (!p.img.complete) {
          p.img.onload = p.img.onerror = null;
          p.img.removeAttribute("srcset");
          p.img.removeAttribute("src");
          delete galleryWarmed[p.id];
        }
        return false;
      });
    }

    function galleryTargetItem(key) {
      var list = galleryImagesFor(key);
      var index = list ? Math.min(deskGalleryTargetIndex(), list.length) : 0;
      var item = index > 0 ? list[index - 1] : null;
      return item && !item.v ? item : null;
    }

    function warmGallery(key, thumbPriority, hover) {
      var list = galleryImagesFor(key);
      if (!list) return;

      var item = galleryTargetItem(key);
      if (item) {
        warmGalleryImage(item.u, galleryImageSrcset(item.u), "high", true, hover);
      }

      $.each(list, function (i, entry) {
        warmGalleryImage(galleryImageUrl(entry.u, "100x"), "", thumbPriority || "low", false, hover);
      });
    }

    function galleryKeyForButton($button) {
      var variantId = galleryVariantIdForButton($button);
      return variantId ? galleryCacheKey(variantId, $button) : "";
    }

    function warmGallerySlideForColors(index) {
      if (index < 1 || !deskKeepGalleryIndex()) return;
      if (typeof window.deskConnectionAllows === "function" && !window.deskConnectionAllows(false)) return;

      var limits = window.deskWarmLimits || { max: 16, held: 6 };
      var slow = typeof window.deskConnectionAllows === "function" && !window.deskConnectionAllows(true);
      var max = slow ? 4 : limits.max;
      var count = 0;
      var buttons = [];

      $(".pp_opt_color_options_1, .pp_opt_color_options_2").each(function () {
        var $group = $(this).find(".pp_var_select__js:not(.pp_var_hidden)");
        var active = Math.max(0, $group.index($group.filter(".active")));
        $group.each(function (i) {
          if (!$(this).hasClass("active")) buttons.push({ $button: $(this), distance: Math.abs(i - active) });
        });
      });

      buttons.sort(function (a, b) {
        return a.distance - b.distance;
      });

      $.each(buttons, function (i, entry) {
        if (count >= max) return false;

        var list = galleryImagesFor(galleryKeyForButton(entry.$button));
        var item = list && list[Math.min(index, list.length) - 1];
        if (!item || item.v) return;

        var srcset = galleryImageSrcset(item.u);
        if (galleryWarmed[srcset]) return;
        warmGalleryImage(item.u, srcset, "low", count < limits.held);
        count += 1;
      });
    }

    var galleryWarmTimer = null;

    function scheduleGallerySlideWarm() {
      clearTimeout(galleryWarmTimer);
      galleryWarmTimer = setTimeout(function () {
        var run = function () {
          warmGallerySlideForColors(window.pdpGalleryIndex || 0);
        };
        if (window.requestIdleCallback) window.requestIdleCallback(run, { timeout: 1500 });
        else setTimeout(run, 200);
      }, 300);
    }

    $(document).on("desk:gallery-slide desk:variant-change", scheduleGallerySlideWarm);

    function swapGalleryNow(key) {
      var list = galleryImagesFor(key);
      if (!list) return;
      gallerySwappedKey = key;

      $(".product_main_gallery_thumbs__js .swiper-slide").each(function (i) {
        if (i === 0 || !list[i - 1]) return;
        $(this)
          .find("img.product-single__thumb")
          .attr("src", galleryImageUrl(list[i - 1].u, "100x"));
      });

      var currentIndex = deskGalleryTargetIndex();
      var item = list[Math.min(currentIndex, list.length) - 1];
      if (currentIndex < 1 || !item || item.v) return;

      var $img = $(".mySwiper2 .swiper-slide")
        .eq(currentIndex)
        .find("img.img-cover");
      if (!$img.length) return;

      $img
        .css("background", 'url("' + galleryImageUrl(item.u, "100x") + '") center / cover no-repeat')
        .attr("fetchpriority", "high")
        .attr("sizes", gallerySlideSizes())
        .attr("srcset", galleryImageSrcset(item.u))
        .attr("src", item.u)
        .removeAttr("data-srcset data-src");
      if ($img.attr("data-mfp-src")) {
        $img.attr("data-mfp-src", galleryImageUrl(item.u, "1024x1024"));
      }
    }

    function setGalleryFirst(variantId) {
      var key = galleryCacheKey(variantId);
      if (key === galleryRenderedKey) {
        if (gallerySwappedKey && gallerySwappedKey !== key) {
          galleryFilterToken++;
          swapGalleryNow(key);
        }
        return;
      }

      swapGalleryNow(key);
      var token = ++galleryFilterToken;

      fetchGallerySlides(variantId, key, function (parts) {
        if (!parts) return;
        whenGalleryReady(parts, function () {
          afterNextPaint(function () {
            if (token !== galleryFilterToken) return;
            if (filterImages(parts)) {
              galleryRenderedKey = key;
              gallerySwappedKey = null;
            }
          });
        });
      });
    }

    getVariant();

    function onVariantsReady() {
      if (window.stockLoaded !== true) getVariant();
    }

    if (window.deskVariantsReady === true) {
      onVariantsReady();
    } else {
      document.addEventListener("desk:variants-ready", onVariantsReady, { once: true });
    }

    var variantRetries = 0;
    var variantRetryId = setInterval(function () {
      variantRetries += 1;
      if (window.stockLoaded === true || variantRetries > 10) {
        clearInterval(variantRetryId);
        return;
      }
      getVariant();
    }, 1000);
  
    function pdpGalleryPrev() {
      window.pdpGoToSlide((window.pdpGalleryIndex || 0) - 1);
    }
    function pdpGalleryNext() {
      window.pdpGoToSlide((window.pdpGalleryIndex || 0) + 1);
    }

    $(".custom-mobile-buttons__next").click(function () {
      pdpGalleryNext();
    });

    $(".custom-mobile-buttons__prev").click(function () {
      pdpGalleryPrev();
    });

    $(".product_main_gallery_thumbs__js .slider__gallery-item-btn_next").click(
      function () {
        pdpGalleryNext();
        $(
          ".product_main_gallery_thumbs__js .slider__gallery-item-btn_prev",
        ).removeClass("swiper-button-disabled");
      },
    );

    $(".product_main_gallery_thumbs__js .slider__gallery-item-btn_prev").click(
      function () {
        pdpGalleryPrev();
        $(
          ".product_main_gallery_thumbs__js .slider__gallery-item-btn_next",
        ).removeClass("swiper-button-disabled");
      },
    );
  
    window.filteringActive = false;

    var galleryCache = {};
    var galleryWaiting = {};
    var galleryTimeout = 8000;

    function galleryCacheKey(variantId, $button) {
      var option1 =
        $(
          ".pp_opt_color_options_1 .pp_selection_color_btn.pp_var_select__js.active",
        ).attr("data-option-title") || "";

      var option2 = $(
        ".pp_opt_color_options_2 .pp_selection_color_btn.pp_var_select__js.active",
      ).attr("data-option-title");

      if (!option2) {
        option2 = $(
          ".pp_opt_color_options_2 .pp_images-set-button.pp_var_select__js.active",
        ).attr("data-option-title");
      }

      if ($button && $button.length) {
        var hovered = $button.attr("data-option-title") || "";
        if ($button.closest(".pp_opt_color_options_1").length) {
          option1 = hovered;
        } else if ($button.closest(".pp_opt_color_options_2").length) {
          option2 = hovered;
        }
      }

      if (!option1) return String(variantId);
      return option2 ? option1 + " / " + option2 : option1;
    }

    function galleryVariantIdForButton($button) {
      var $actives = $(".pp_var_select__js.active");
      if (!$actives.length) return "";

      var index = $button.attr("data-index");
      var title = "";
      var missing = false;

      $actives.each(function () {
        var $active = $(this);
        var value =
          $active.attr("data-index") === index
            ? $button.attr("data-value")
            : $active.attr("data-value");

        if (!value) {
          missing = true;
          return false;
        }
        title += value + "-";
      });

      if (missing || !title) return "";

      try {
        return (
          $('.pp_variant_config[data-title="' + title.slice(0, -1) + '"]').attr(
            "data-id",
          ) || ""
        );
      } catch (err) {
        return "";
      }
    }

    function prefetchGallery($button) {
      if (!$button || !$button.length) return;

      var variantId = galleryVariantIdForButton($button);
      if (!variantId) return;

      var key = galleryCacheKey(variantId, $button);
      if (key === galleryRenderedKey) return;

      var preloadTarget = function (parts) {
        var targetIndex = deskGalleryTargetIndex();
        if (parts && targetIndex > 0 && !galleryTargetItem(key)) preloadGallerySlide(parts, targetIndex);
      };

      if (galleryCache[key]) {
        preloadTarget(galleryCache[key]);
        return;
      }
      if (galleryWaiting[key]) return;

      fetchGallerySlides(variantId, key, preloadTarget);
    }

    var galleryPrefetchTimer = null;
    var galleryHoverButton = null;

    $(document).on("pointerover", ".pp_var_select__js", function () {
      if (this === galleryHoverButton) return;
      var $button = $(this);
      galleryHoverButton = this;
      clearTimeout(galleryPrefetchTimer);
      galleryPrefetchTimer = setTimeout(function () {
        var key = $button.hasClass("active") ? "" : galleryKeyForButton($button);
        cancelGalleryPending(key, true);
        if (key) warmGallery(key, "low", true);
        prefetchGallery($button);
      }, 100);
    });

    $(document).on("pointerout", ".pp_var_select__js", function (event) {
      if (this !== galleryHoverButton || $.contains(this, event.relatedTarget)) return;
      clearTimeout(galleryPrefetchTimer);
      galleryHoverButton = null;
    });

    $(document).on("pointerdown", ".pp_var_select__js", function (event) {
      var $button = $(this);
      clearTimeout(galleryPrefetchTimer);
      galleryHoverButton = null;

      if (event.button === 0 && !$button.hasClass("active")) {
        var key = galleryKeyForButton($button);
        if (key && key !== galleryRenderedKey) {
          cancelGalleryPending(key, false);
          warmGallery(key, "high");
          swapGalleryNow(key);
          setTimeout(function () {
            if ($button.hasClass("active") || gallerySwappedKey !== key) return;
            swapGalleryNow(galleryRenderedKey);
          }, 600);
        }
      }

      prefetchGallery($button);
    });

    function galleryError(message) {
      var err = new Error(message);
      err.permanent = true;
      return err;
    }

    function galleryWarn(message, err) {
      if (window.console && window.console.warn) {
        window.console.warn(message, err);
      }
    }

    function galleryParse(html) {
      if (!html || typeof html !== "string") return null;
      if (typeof DOMParser !== "function") return null;

      var doc = null;
      try {
        doc = new DOMParser().parseFromString(html, "text/html");
      } catch (err) {
        return null;
      }
      if (!doc) return null;

      var main = doc.querySelector("[data-gallery-main]");
      var thumbs = doc.querySelector("[data-gallery-thumbs]");
      if (!main && !thumbs) return null;

      var thumbUrls = [];
      if (thumbs) {
        $(thumbs).find("img").each(function () {
          var src = this.getAttribute("src");
          if (src && thumbUrls.indexOf(src) === -1) thumbUrls.push(src);
        });
      }

      var slideImages = [];
      if (main) {
        $(main)
          .find(".product-single__media-flex-wrapper")
          .each(function () {
            var $slideImg = $(this).find("img[data-srcset]").first();
            slideImages.push(
              $slideImg.length
                ? {
                    src: $slideImg.attr("data-src") || "",
                    srcset: $slideImg.attr("data-srcset") || "",
                    sizes: $slideImg.attr("sizes") || "",
                  }
                : null,
            );
          });
      }

      return {
        main: main ? main.innerHTML : "",
        thumbs: thumbs ? thumbs.innerHTML : "",
        thumbUrls: thumbUrls,
        slideImages: slideImages,
        slideReady: {},
        slideDone: {},
      };
    }

    function preloadGallerySlide(parts, slideIndex) {
      if (!parts || !parts.slideImages || slideIndex < 1) return null;
      if (parts.slideReady[slideIndex]) return parts.slideReady[slideIndex];

      var imageData = parts.slideImages[slideIndex - 1];
      if (!imageData || !imageData.src) return null;

      var preloadImg = new Image();
      preloadImg.decoding = "async";
      preloadImg.setAttribute("fetchpriority", "high");
      if (imageData.sizes) preloadImg.sizes = imageData.sizes;
      if (imageData.srcset) preloadImg.srcset = imageData.srcset;
      preloadImg.src = imageData.src;

      var loaded = preloadImg.decode
        ? preloadImg.decode().catch(function () {})
        : new Promise(function (resolve) {
            preloadImg.onload = preloadImg.onerror = resolve;
          });

      parts.slideReady[slideIndex] = loaded.then(function () {
        parts.slideDone[slideIndex] = true;
      });
      return parts.slideReady[slideIndex];
    }

    function preloadGalleryThumbs(parts) {
      if (!parts || !parts.thumbUrls || !parts.thumbUrls.length) return;

      var loads = $.map(parts.thumbUrls, function (url) {
        var img = new Image();
        img.decoding = "async";
        img.src = url;
        if (img.decode) return img.decode().catch(function () {});
        return new Promise(function (resolve) {
          img.onload = img.onerror = resolve;
        });
      });

      parts.thumbsReady = Promise.all(loads).then(function () {
        parts.thumbsDone = true;
      });
    }

    function galleryLoad(endpoint) {
      if (typeof fetch !== "function" || typeof Promise !== "function") {
        return Promise.reject(galleryError("fetch unavailable"));
      }

      var controller = null;
      var timer = null;

      if (typeof AbortController === "function") {
        controller = new AbortController();
        timer = setTimeout(function () {
          controller.abort();
        }, galleryTimeout);
      }

      function clear() {
        if (timer) {
          clearTimeout(timer);
          timer = null;
        }
      }

      return fetch(endpoint, controller ? { signal: controller.signal } : {})
        .then(function (res) {
          if (!res) throw galleryError("gallery no response");
          if (!res.ok) throw galleryError("gallery HTTP " + res.status);
          return res.text();
        })
        .then(function (html) {
          clear();
          var parts = galleryParse(html);
          if (!parts) throw galleryError("gallery markup missing");
          return parts;
        })
        .catch(function (err) {
          clear();
          throw err;
        });
    }

    function fetchGallerySlides(variantId, key, done) {
      if (typeof done !== "function") return;

      var $gallery = $(".mySwiper2");
      var url = $gallery.attr("data-gallery-url");
      var sectionId = $gallery.attr("data-gallery-section");

      if (!url || !sectionId || !variantId || !key) {
        done(null);
        return;
      }

      if (galleryCache[key]) {
        done(galleryCache[key]);
        return;
      }

      if (galleryWaiting[key]) {
        galleryWaiting[key].push(done);
        return;
      }
      galleryWaiting[key] = [done];

      var endpoint =
        url +
        (url.indexOf("?") === -1 ? "?" : "&") +
        "section_id=" +
        encodeURIComponent(sectionId) +
        "&variant=" +
        encodeURIComponent(variantId);

      function flush(parts) {
        var queue = galleryWaiting[key] || [];
        delete galleryWaiting[key];

        $.each(queue, function (i, cb) {
          try {
            cb(parts);
          } catch (err) {
            galleryWarn("Gallery render failed", err);
          }
        });
      }

      galleryLoad(endpoint)
        .catch(function (err) {
          if (err && err.permanent) throw err;
          return galleryLoad(endpoint);
        })
        .then(function (parts) {
          preloadGalleryThumbs(parts);
          galleryCache[key] = parts;
          flush(parts);
        })
        .catch(function (err) {
          galleryWarn("Gallery fetch failed for variant " + variantId, err);
          flush(null);
        });
    }

    // media id → detached, already-loaded video slide (see filterImages)
    var deskVideoSlides = {};

    function filterImages(parts) {
      if (!parts) return false;

      var $slides = $(
        ".product-single__media-group .product-single__media-flex-wrapper",
      );
      if (!$slides.length) return false;

      var was3dOpen =
        $(".product-3d-window").hasClass("open") || window.mmqShowed;
      var targetIndex = deskGalleryTargetIndex();
      window.filteringActive = true;
      setTimeout(function () {
        window.filteringActive = false;
      }, 500);

      var $thumbs = $(".product-single__thumbnails li");
      if ($thumbs.length) {
        $thumbs.not(":first").remove();
        if (parts.thumbs) $thumbs.first().after(parts.thumbs);
      }

      // Video slides are shared across variants (same media id = same file). Keep the
      // existing DOM nodes — with whatever the <video> already buffered — and swap them
      // into the new gallery instead of re-creating and re-downloading the video.
      $slides.not(":first").each(function () {
        var $slide = $(this);
        var id = $slide.attr("data-count");
        if (id && $slide.find("video").length) {
          $slide.find("video").each(function () { this.pause(); });
          deskVideoSlides[id] = $slide.detach();
        }
      });

      // re-query: the detached video slides must not be .remove()d (that would wipe them)
      $(".product-single__media-group .product-single__media-flex-wrapper")
        .not(":first")
        .remove();
      if (parts.main) $slides.first().after(parts.main);

      $(".product-single__media-group .product-single__media-flex-wrapper")
        .not(":first")
        .each(function () {
          var $fresh = $(this);
          var id = $fresh.attr("data-count");
          if (id && deskVideoSlides[id] && $fresh.find("video").length) {
            $fresh.replaceWith(deskVideoSlides[id]);
          }
        });

      var slideCount = $(
        ".product-single__media-group .product-single__media-flex-wrapper",
      ).length;
      targetIndex = Math.max(0, Math.min(targetIndex, slideCount - 1));

      if (targetIndex > 0 && typeof window.deskLoadGallerySlide === "function") {
        window.deskLoadGallerySlide(targetIndex, true);
      }

      window.lastActiveGallery = targetIndex;
      if (typeof window.resetSwipers === "function") {
        window.resetSwipers();
      } else {
        galleryWarn("resetSwipers unavailable");
      }


      if (was3dOpen && targetIndex === 0) {
        $(".product-3d-window").addClass("open");
        $(".product__media-zoomin-btns").addClass("activated");
      } else if (targetIndex !== 0) {
        $(".product-3d-window").removeClass("open");
      }

      return true;
    }

    function setVariant(variantId) {
      var variantSrc =
        (window.deskVariantImages && window.deskVariantImages[variantId]) ||
        $('.pp_variant_config[data-id="' + variantId + '"]').attr(
          "data-featured-img",
        );

        
      $("#product-variant__src")
        .attr("fetchpriority", deskGalleryTargetIndex() === 0 ? "high" : "low")
        .attr("src", variantSrc);
      $("#product-variant__thumb").attr("src", variantSrc);
  
      $(".pp_config__main_id-js").attr("data-id", variantId);
      $("#ProductPrice").attr("data-variant-id", variantId);
      $("#PriceDiscount").attr("data-variant-id", variantId);
      $("#ComparePrice").attr("data-variant-id", variantId);
      $("shopify-payment-terms").attr("variant-id", variantId);
      $("delivery-promise-wc").attr("variant-id", variantId);
      $(".product_thumb-sticky").attr("src", variantSrc);
      if (variantSrc) {
        $(".desk_sticky-atc__img").attr("src", variantSrc);
        $(".desk_main-pdp-one-image").attr("src", variantSrc);
      }
    }
  
    function updatePriceDisplay(variantId) {
  var $config = $('.pp_variant_config[data-id="' + variantId + '"]');
  if (!$config.length) return;

  var price    = $config.attr('data-price')    || '';
  var compare  = $config.attr('data-compare')  || '';
  var discount = $config.attr('data-discount') || 'false';

  var hasCompare  = compare  !== '';
  var hasDiscount = discount !== 'false' && discount !== '';

var $thirtyDayPriceEl = $('.product-single__30days-price');
if (!hasDiscount || !$thirtyDayPriceEl.length) {
  $thirtyDayPriceEl.hide();
  $('.product-single_price_info_line>div').removeClass('day30Visible');
} else {
  $thirtyDayPriceEl.show();
  $('.product-single_price_info_line>div').addClass('day30Visible');
}

  var $thirtyDaysPrice = $(".product-single__30days-price-variant");
  var min30Raw = $config.attr('data-min-pricing-30');
  $thirtyDaysPrice.html(min30Raw);

  var $priceLine = $('product-price-container price-line');
  if (!$priceLine.length) return;

  $priceLine.find('real-price').html(price);

  var $compareEl = $priceLine.find('compare-price');
  if (hasCompare) {
    if (!$compareEl.length) {
      $compareEl = $('<compare-price></compare-price>');
      $priceLine.find('real-price').after($compareEl);
    }
    $compareEl.html(compare).css('display', '');
  } else {
    $compareEl.hide();
  }

  var $discountEl = $priceLine.find('price-discount');
  if (hasDiscount) {
    if (!$discountEl.length) {
      $discountEl = $('<price-discount></price-discount>');
      $priceLine.find('compare-price, real-price').last().after($discountEl);
    }
    var pctNum = parseInt(String(discount).replace(/[^0-9]/g, ''), 10) || 0;
    var badgeText = window.deskDiscountBadge ? window.deskDiscountBadge(pctNum, price, compare) : discount;
    $discountEl.html(badgeText).css('display', '');
  } else {
    $discountEl.hide();
  }
}

    function setPrice(variantId) {
      updatePriceDisplay(variantId);
      if (window.updateTotalPrice) window.updateTotalPrice();
    }
  
    function updateURLParameter(param, value) {
      var url = new URL(window.location.href);
      url.searchParams.set(param, value);
      window.history.replaceState({}, "", url);
    }
  
    function getUrlParameters() {
      var params = {};
      var queryString = window.location.search.substring(1);
  
      if (queryString) {
        var pairs = queryString.split("&");
        $.each(pairs, function (i, pair) {
          var parts = pair.split("=");
          var key = decodeURIComponent(parts[0]);
          var value = decodeURIComponent(parts[1] || "");
          params[key] = value;
        });
      }
  
      return params;
    }
  
    function setDefault() {
      var urlParams = getUrlParameters();
      var variantId = urlParams["variant"];
      if (!variantId) {
        $("#product-variant__src").addClass("active");
        variantId = $(".pp_variant_config").first().attr("data-id");
      }
  
      var currentProductId = $(
        '.pp_variant_config[data-id="' + variantId + '"]',
      ).attr("data-product-id");
  
      var option1 = $('.pp_variant_config[data-id="' + variantId + '"]').attr(
        "data-option1",
      );
      var option2 = $('.pp_variant_config[data-id="' + variantId + '"]').attr(
        "data-option2",
      );
      var option3 = $('.pp_variant_config[data-id="' + variantId + '"]').attr(
        "data-option3",
      );
  
      console.log(option1, option2, option3);
  
      $("#product-variant__src").addClass("active");
  
      var stock = $('.pp_variant_config[data-id="' + variantId + '"]').attr(
        "data-stock",
      );
      if (stock == "0") {
      } else {
      }
  
      window.notFirstLoad = true;
    }
  
    setDefault();
  
    window.stockLoaded = false;
  
    // Marks one option button for the combination `variantTitle`:
    //   stock 0                                  → .soldOut (crossed out, still selectable → OOS popup)
    //   stock 0 + variant custom.hide_when_sold_out → also .pp_var_hidden (display:none, not selectable)
    // data-hide-soldout comes from desk_config_fetchAllVariants.liquid.
    function markStock($btn, variantTitle) {
      var $cfg = $('.pp_variant_config[data-title="' + variantTitle + '"]');
      if ($cfg.attr("data-stock") !== "0") return;
      $btn.addClass("soldOut");
      if ($cfg.attr("data-hide-soldout") === "true") $btn.addClass("pp_var_hidden");
    }

    // If the selected value just got hidden, move the selection to the first visible
    // in-stock value of the same option group (same pattern as rizer-top-hidden).
    var deskHiddenSwitching = false;
    function switchFromHiddenActive() {
      if (deskHiddenSwitching) return;
      $(".pp_opt_color").each(function () {
        var $active = $(this).find(".pp_var_select__js.active.pp_var_hidden");
        if (!$active.length) return;

        var $visible = $(this).find(".pp_var_select__js").not(".pp_var_hidden, .rizer-top-hidden");
        var $replacement = $visible.not(".soldOut").first();
        if (!$replacement.length) $replacement = $visible.first();
        if (!$replacement.length) return;

        deskHiddenSwitching = true;
        setTimeout(function () {
          $replacement.trigger("click");
          deskHiddenSwitching = false;
        }, 0);
        return false;
      });
    }

    // Option group number (1..3) of a button, taken from its .pp_opt_color_options_N wrapper
    // (falls back to data-index).
    function deskOptionIndex($btn) {
      var $group = $btn.closest(".pp_opt_color");
      var m = ($group.attr("class") || "").match(/pp_opt_color_options_(\d+)/);
      return m ? Number(m[1]) : Number($btn.attr("data-index")) || 0;
    }

    function setStock(variantId) {
      $(".pp_var_select__js").removeClass("soldOut pp_var_hidden");

      // Currently selected value per option group: { 1: "black", 2: "oak", 3: "160x80-cm" }
      // Works for any number/order of options — the old version assumed option3 = size and
      // read it from .pp_selection_size_btn, which is also used for "Typ"/"Mod"/"Tip" options
      // in position 1–2, so titles didn't match and .soldOut was skipped for some buttons.
      var selected = {};
      $(".pp_var_select__js.active").each(function () {
        var idx = deskOptionIndex($(this));
        if (idx && selected[idx] === undefined) selected[idx] = $(this).attr("data-value") || "";
      });
      var indexes = Object.keys(selected).map(Number).sort(function (a, b) { return a - b; });

      // Each button is checked against the combination "its value + current selection of the other groups".
      $(".pp_var_select__js").each(function () {
        var $btn = $(this);
        var idx = deskOptionIndex($btn);
        if (!idx) return;

        var parts = indexes.map(function (i) {
          return i === idx ? ($btn.attr("data-value") || "") : selected[i];
        });
        if (indexes.indexOf(idx) === -1) parts.push($btn.attr("data-value") || "");

        markStock($btn, parts.join("-"));
      });

      switchFromHiddenActive();

      if (typeof variantId !== "undefined") {
        var currentStockValue = $(
          '.pp_variant_config[data-id="' + variantId + '"]',
        ).attr("data-stock");
        if (currentStockValue === "0") {
          $(".product-single__buy-wrapper").addClass("disabled");
          $(".product__out-of-stock").addClass("active");
          $(".mobile-sticky-atc-btn__wrapper").addClass("disabled");
          $(".mobile-sticky-sold-out-btn__wrapper").removeClass("disabled");
          $("#tidio-chat").addClass("outOfStockVisible");
        } else {
          $(".product-single__buy-wrapper").removeClass("disabled");
          $(".product__out-of-stock").removeClass("active");
          $(".mobile-sticky-sold-out-btn__wrapper").addClass("disabled");
          $(".mobile-sticky-atc-btn__wrapper").removeClass("disabled");
          $("#tidio-chat").removeClass("outOfStockVisible");
        }
  
        window.stockLoaded = true;
      }
    }
  
    function setAddons(variantId) {
      var currentAddOnMode = $(
        '.pp_variant_config[data-id="' + variantId + '"]',
      ).attr("data-disabled-addon");
      if (currentAddOnMode == "true") {
        $(".addons_free-gift_note").addClass("hided");
        $(".data-identifier-disabled").addClass("add-one-disabled");
        $(".product-single_free_gift_badge").addClass("hided");
        $(".data-identifier-disabled")
          .find(".addOneMainInput__js")
          .prop("checked", false);

        $('top-addon-card[data-addon-disabled-one-120="true"]').each(function () {
          var $card = $(this);
          $card.addClass('disabledAddon');
          if ($card.hasClass('activated')) {
            $card.removeClass('activated');
            var $mainInput = $card.children('input.addOneMainInput__js');
            if ($mainInput.length) {
              var block = $mainInput.attr('data-mmq-block');
              var code = $mainInput.attr('data-mmq-hide-code');
              if (block && code) {
                setTimeout(function () {
                  if (!window.mmqLoaded) return;
                  window.mimeeqApp.actions.markOptionByBlockNameAndOptionCode(block, code);
                }, 1500);
              }
            }
          }
        });

        var productQnt = 1;
        $(".add-one__3d-checked input:checked").each(function () {
          productQnt++;
        });
  
        if (productQnt > 1) {
          var atcText = $(".js-custom-add-to-cart")
            .attr("data-title-qnt")
            .replace("{}", productQnt);
          $(".desk_btn_content").find("span").html(atcText);
          $(".mobile-sticky-atc-btn__handlers")
            .find(".desk_btn_content")
            .html(atcText);
        } else {
          var atcText = $(".js-custom-add-to-cart").attr("data-title");
          $(".desk_btn_content").find("span").html(atcText);
          $(".mobile-sticky-atc-btn__handlers")
            .find(".desk_btn_content")
            .html(atcText);
        }
      } else {
        $(".data-identifier-disabled").removeClass("add-one-disabled");
        $(".addons_free-gift_note").removeClass("hided");
        $(".product-single_free_gift_badge").removeClass("hided");
        $('top-addon-card[data-addon-disabled-one-120="true"]').each(function () {
          var $card = $(this);
          $card.removeClass('disabledAddon');
          if (!$card.hasClass('activated')) {
            var $mainInput = $card.children('input.addOneMainInput__js');
            if ($mainInput.length) {
              var block = $mainInput.attr('data-mmq-block');
              var code = $mainInput.attr('data-mmq-hide-code');
              if (block && code) {
                setTimeout(function () {
                  if (!window.mmqLoaded) return;
                  window.mimeeqApp.actions.markOptionByBlockNameAndOptionCode(block, code);
                }, 1500);
              }
            }
          }
        });
      }
    }
  
    $(".product_price-popup-trigger").click(function () {
      $(".product-price-comparison_outer").css("display", "flex");
      $(".product-price-outer_whole").show();
      $("body").addClass("popup-open");
      window.lockScroll();
    });

    $(".product-price-popup_close").click(function () {
      $(".product-price-comparison_outer").hide();
      $(".product-price-outer_whole").hide();
      $("body").removeClass("popup-open");
      window.unlockScroll();
    });
  
    $(".product-colors-popup_close, .product-colors-popup__btn").click(function () {
      $(".product-colors-comparison_outer").hide();
      $(".product-comparison-outer_whole").hide();
      $("body").removeClass("popup-open");
      window.unlockScroll();
    });

    $(document).on("click", ".product-colors-popup__footer_left a", function (e) {
      e.preventDefault();
      if (this.href) window.open(this.href, "_blank", "noopener");
    });

    $(".pp_colors_info").click(function () {
      var currentData = $(this).attr("data");
      $('.product-comparison-outer_whole[data="' + currentData + '"]')
        .find(".product-colors-comparison_outer")
        .css("display", "flex");
      $('.product-comparison-outer_whole[data="' + currentData + '"]').show();
      $("body").addClass("popup-open");
      window.lockScroll();
    });
  
    $(".product-charity-popup_close").click(function (evt) {
      evt.preventDefault();
      $(".product-charity-outer_whole").hide();
      $("body").removeClass("popup-open");
    });
  
    $(".charity-note_line").on("click", function (evt) {
      const screenWidth = $(window).width();
      const target = $(evt.target);
  
      if (target.is(".charity-label__js")) {
        if (screenWidth < 678) {
          evt.preventDefault();
          $(".product-charity-outer_whole").show();
          $("body").addClass("popup-open");
          $(".product-charity-comparison_outer").css("display", "flex");
          var winHeight = $(window).height();
          if (winHeight > 1000) {
            if ($(window).width() > 678) {
              var popupHeight = $(
                ".product-charity-comparison_popup",
              ).outerHeight();
              $(".product-charity-popup_close").css(
                "top",
                "calc(50% - " + popupHeight / 2 + "px + 16px)",
              );
              $(".product-charity-comparison_outer").css("align-items", "center");
            }
          } else {
            $(".product-charity-comparison_outer").css(
              "align-items",
              "flex-start",
            );
            $(".product-charity-popup_close").css("top", "72px");
          }
        } else {
        }
      } else if (target.is("a")) {
        evt.preventDefault();
        $(".product-charity-outer_whole").show();
        $("body").addClass("popup-open");
        $(".product-charity-comparison_outer").css("display", "flex");
        var winHeight = $(window).height();
        if (winHeight > 1000) {
          if ($(window).width() > 678) {
            var popupHeight = $(
              ".product-charity-comparison_popup",
            ).outerHeight();
            $(".product-charity-popup_close").css(
              "top",
              "calc(50% - " + popupHeight / 2 + "px + 16px)",
            );
            $(".product-charity-comparison_outer").css("align-items", "center");
          }
        } else {
          $(".product-charity-comparison_outer").css("align-items", "flex-start");
          $(".product-charity-popup_close").css("top", "72px");
        }
      }
    });
  
    $(".form_input-line input").on("input", function () {
      var $inputLine = $(this).closest(".form_input-line");
  
      if ($(this).val().trim() !== "") {
        $inputLine.addClass("hasValue");
  
        var inputType = $(this).attr("data-type");
        if (inputType === "email") {
          var value = $(this).val().trim();
          var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  
          if (emailRegex.test(value)) {
            $inputLine.removeClass("invalid");
          } else {
            $inputLine.addClass("invalid");
          }
        }
  
        if (inputType == "web") {
          var value = $(this).val();
          if (String(value).indexOf(".") > 0) {
            $inputLine.removeClass("invalid");
          } else {
            $inputLine.addClass("invalid");
          }
        }
      } else {
        $inputLine.removeClass("hasValue");
        $inputLine.removeClass("invalid");
      }
    });
  
    $(".form_input-line").click(function () {
      var input = $(this).find("input");
      input.focus();
      $(".form_input-line").removeClass("active");
      $(this).addClass("active");
    });

    $(document).on("click", function (e) {
      if (!$(e.target).closest(".form_input-line").length) {
        $(".form_input-line").removeClass("active");
      }
    });
  
    $(".price_match-submit").click(function (e) {
      e.preventDefault();
      var $form = $(this).closest("form");
      var formValid = true;
      $form.find(".form_input-line").each(function () {
        var value = ($(this).find("input").val() || "").trim();
        if (value == "") {
          $(this).addClass("invalid");
          formValid = false;
        } else {
          $(this).removeClass("invalid");
        }
      });

      if (formValid == true) {
        if (typeof window.submitPriceMathcKlaviyo === 'function') window.submitPriceMathcKlaviyo();
        $form.submit();
      }
    });

    $(".product-single_free_gift_badge").mouseover(function () {
      $(this).find(".product-single_free_gift_tooltip").show();
    });
  
    $(".product-single_free_gift_badge").mouseleave(function () {
      $(this).find(".product-single_free_gift_tooltip").hide();
    });
  
    $(document).on(
      "click",
      ".mobile-sticky-sold-out-btn__wrapper button",
      function () {
        $("#productOut")[0].scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      },
    );
  
    $(document).on(
      "click",
      ".add--one--modal__handler--box .addone_item-switch",
      function () {
        $(".add--one--modal__handler--box").addClass("loading");
        setTimeout(function () {
          $(".add--one--modal__handler--box").removeClass("loading");
        }, 500);
        $(this)
          .closest(".addone_items-product-switch")
          .find(".addone_item-switch")
          .removeClass("active");
        $(this).addClass("active");
        var data = $(this).attr("data");
  
        var productId = $(this)
          .closest(".addone_items-product-switch")
          .attr("data-product-id");
  
        var productIdReal = $(this).attr("data-product-id");
        $(".add--one--modal__content").attr("data-product-id", productIdReal);
        $('.product-single__add-one[id="addone-' + productId + '"]').attr(
          "data-id",
          productIdReal,
        );
  
        var ratingScore = $(this).attr("data-reviews-rating");
        $('.product-single__add-one[id="addone-' + productId + '"]')
          .find(".add-one_rating_count p")
          .html(ratingScore);
  
        var ratingScoreInt = parseFloat(ratingScore);
        if (ratingScoreInt < 0.5) {
          $('.product-single__add-one[id="addone-' + productId + '"]')
            .find(".add-one_rating_line")
            .css("opacity", "0");
          $("#mainProduct").addClass("reviewsHided");
        } else {
          $('.product-single__add-one[id="addone-' + productId + '"]')
            .find(".add-one_rating_line")
            .css("opacity", "1");
          $("#mainProduct").removeClass("reviewsHided");
        }
  
        $(
          '.addone_items-product-switch__outer .addone_items-product-switch[data-product-id="' +
            productId +
            '"]',
        )
          .find(".addone_item-switch")
          .removeClass("active");
        $(
          '.addone_items-product-switch__outer .addone_items-product-switch[data-product-id="' +
            productId +
            '"]',
        )
          .find('.addone_item-switch[data="' + data + '"]')
          .addClass("active");
  
        $('.product-single__add-one[id="addone-' + productId + '"]')
          .find(".add-one__variants")
          .addClass("hided");
        $('.product-single__add-one[id="addone-' + productId + '"]')
          .find('.add-one__variants[data="' + data + '"]')
          .removeClass("hided");
  
        if (data == "org") {
          var selectedBubble = $(
            '.product-single__add-one[id="addone-' + productId + '"]',
          ).find(".product__additional-variant input:checked");
  
          var newVariantId = selectedBubble.attr("data-id");
          var newPrice = $(
            '.pa_label_variant__js[data-id="' + newVariantId + '"]',
          ).attr("data-price");
          var newComparePrice = $(
            '.pa_label_variant__js[data-id="' + newVariantId + '"]',
          ).attr("data-compare-price");
          var newBadge = $(
            '.pa_label_variant__js[data-id="' + newVariantId + '"]',
          ).attr("data-discount");
          var newImage = $(
            '.pa_label_variant__js[data-id="' + newVariantId + '"]',
          ).attr("data-src");
  
          var mmqBlock = selectedBubble.attr("data-mmq-block");
          var mmqCode = selectedBubble.attr("data-mmq-code");
  
          $('.product-single__add-one[id="addone-' + productId + '"]')
            .find(".addOneMainInput__js")
            .attr("data-mmq-block", mmqBlock);
          $('.product-single__add-one[id="addone-' + productId + '"]')
            .find(".addOneMainInput__js")
            .attr("data-mmq-code", mmqCode);
          $('.product-single__add-one[id="addone-' + productId + '"]')
            .find(".addOneMainInput__js")
            .attr("data-id", newVariantId);
          $('.product-single__add-one[id="addone-' + productId + '"]')
            .find(".add-one__image img")
            .attr("src", newImage);
          $('.product-single__add-one[id="addone-' + productId + '"]')
            .find(".add-one__prices-current")
            .html(newPrice);
          $('.product-single__add-one[id="addone-' + productId + '"]')
            .find(".add-one__prices-compare-at__money")
            .html(newComparePrice);
          $('.product-single__add-one[id="addone-' + productId + '"]')
            .find(".add-one__prices-current")
            .attr("data-variant-id", newVariantId);
          $('.product-single__add-one[id="addone-' + productId + '"]')
            .find(".add-one__prices-compare-at__money")
            .attr("data-variant-id", newVariantId);
          $('.product-single__add-one[id="addone-' + productId + '"]')
            .find(".add-one__discount")
            .attr("data-variant-id", newVariantId);
          $('.product-single__add-one[id="addone-' + productId + '"]')
            .find(".add-one__discount")
            .html(newBadge);
          $('.product-single__add-one[id="addone-' + productId + '"]')
            .find(".add-one__popup-opener")
            .attr("data-product-id", productIdReal);
  
          resetPopupDate(newVariantId);
          window.calculateTabs(productIdReal, newVariantId);
        } else {
          var selectedBubble = $(
            '.product-single__add-one[id="addone-' + productId + '"]',
          ).find(".addone_color-option-out.active");
          var newVariantId = selectedBubble.attr("data-variant-id");
          var newImage = $(
            '.pa_label_variant__js[data-id="' + newVariantId + '"]',
          ).attr("data-src");
          var newPrice = $(
            '.pa_label_variant__js[data-id="' + newVariantId + '"]',
          ).attr("data-price");
          var newComparePrice = $(
            '.pa_label_variant__js[data-id="' + newVariantId + '"]',
          ).attr("data-compare-price");
          var newBadge = $(
            '.pa_label_variant__js[data-id="' + newVariantId + '"]',
          ).attr("data-discount");
  
          var mmqBlock = selectedBubble.attr("data-mmq-block");
          var mmqCode = selectedBubble.attr("data-mmq-code");
  
          $('.product-single__add-one[id="addone-' + productId + '"]')
            .find(".addOneMainInput__js")
            .attr("data-mmq-block", mmqBlock);
          $('.product-single__add-one[id="addone-' + productId + '"]')
            .find(".addOneMainInput__js")
            .attr("data-mmq-code", mmqCode);
          $('.product-single__add-one[id="addone-' + productId + '"]')
            .find(".addOneMainInput__js")
            .attr("data-id", newVariantId);
          $('.product-single__add-one[id="addone-' + productId + '"]')
            .find(".add-one__image img")
            .attr("src", newImage);
          $('.product-single__add-one[id="addone-' + productId + '"]')
            .find(".add-one__prices-current")
            .html(newPrice);
          $('.product-single__add-one[id="addone-' + productId + '"]')
            .find(".add-one__prices-compare-at__money")
            .html(newComparePrice);
          $('.product-single__add-one[id="addone-' + productId + '"]')
            .find(".add-one__prices-current")
            .attr("data-variant-id", newVariantId);
          $('.product-single__add-one[id="addone-' + productId + '"]')
            .find(".add-one__prices-compare-at__money")
            .attr("data-variant-id", newVariantId);
          $('.product-single__add-one[id="addone-' + productId + '"]')
            .find(".add-one__discount")
            .attr("data-variant-id", newVariantId);
          $('.product-single__add-one[id="addone-' + productId + '"]')
            .find(".add-one__discount")
            .html(newBadge);
          $('.product-single__add-one[id="addone-' + productId + '"]')
            .find(".add-one__popup-opener")
            .attr("data-product-id", productIdReal);
  
          window.calculateTabs(productIdReal, newVariantId);
          resetPopupDate(newVariantId);
        }
  
        $(".modal--color__label.activelabel span").trigger("click");
      },
    );
  
    function resetPopupDate(variantId) {
      var newTitle = $('.pa_label_variant__js[data-id="' + variantId + '"]').attr(
        "data-popup-title",
      );
      var newDescription = $(
        '.pa_label_variant__js[data-id="' + variantId + '"]',
      ).attr("data-popup-description");
      var newbuttonText = $(".pdp_variables_for_popups").data("more");
      var newUrl = $('.pa_label_variant__js[data-id="' + variantId + '"]').attr(
        "data-url",
      );
      var newRating = $(
        '.pa_label_variant__js[data-id="' + variantId + '"]',
      ).attr("data-popup-rating");
  
      console.log(newTitle);
  
      $(".add--one--modal__info--title").html(newTitle);
      $(".add--one--modal__info--description").html(
        newDescription + ` <a href="${newUrl}">${newbuttonText}</a>`,
      );
      $(".add-one_rating_line").html(newRating);
    }
  
    $(".addone_item-switch").click(function () {
  
      $(this)
        .closest(".addone_items-product-switch")
        .find(".addone_item-switch")
        .removeClass("active");
      $(this).addClass("active");
      var data = $(this).attr("data");
      $(this)
        .closest(".product-single__add-one")
        .find(".add-one__variants")
        .addClass("hided");
      $(this)
        .closest(".product-single__add-one")
        .find('.add-one__variants[data="' + data + '"]')
        .removeClass("hided");
  
      var ratingScore = $(this).attr("data-reviews-rating");
      $(this)
        .closest(".product-single__add-one")
        .find(".add-one_rating_count p")
        .html(ratingScore);
  
      var ratingScoreInt = parseFloat(ratingScore);
      if (ratingScoreInt < 0.5) {
        $(this)
          .closest(".product-single__add-one")
          .find(".add-one_rating_line")
          .css("opacity", "0");
        $("#mainProduct").addClass("reviewsHided");
      } else {
        $(this)
          .closest(".product-single__add-one")
          .find(".add-one_rating_line")
          .css("opacity", "1");
        $("#mainProduct").removeClass("reviewsHided");
      }
  
      var productId = $(this).attr("data-product-id");
      $(this)
        .closest(".product-single__add-one")
        .find(".add-one__popup-opener")
        .attr("data-product-id", productId);
      $(this).closest(".product-single__add-one").attr("data-id", productId);
  
      if (data == "org") {
        var selectedBubble = $(this)
          .closest(".product-single__add-one")
          .find(".product__additional-variant input:checked");
  
        var newVariantId = selectedBubble.attr("data-id");
        var newPrice = $(
          '.pa_label_variant__js[data-id="' + newVariantId + '"]',
        ).attr("data-price");
        var newComparePrice = $(
          '.pa_label_variant__js[data-id="' + newVariantId + '"]',
        ).attr("data-compare-price");
        var newBadge = $(
          '.pa_label_variant__js[data-id="' + newVariantId + '"]',
        ).attr("data-discount");
        var newImage = $(
          '.pa_label_variant__js[data-id="' + newVariantId + '"]',
        ).attr("data-src");
  
        var mmqBlock = selectedBubble.attr("data-mmq-block");
        var mmqCode = selectedBubble.attr("data-mmq-code");
  
        $(this)
          .closest(".product-single__add-one")
          .find(".addOneMainInput__js")
          .attr("data-mmq-block", mmqBlock);
        $(this)
          .closest(".product-single__add-one")
          .find(".addOneMainInput__js")
          .attr("data-mmq-code", mmqCode);
        $(this)
          .closest(".product-single__add-one")
          .find(".addOneMainInput__js")
          .attr("data-id", newVariantId);
        $(this)
          .closest(".product-single__add-one")
          .find(".add-one__image img")
          .attr("src", newImage);
        $(this)
          .closest(".product-single__add-one")
          .find(".add-one__prices-current")
          .html(newPrice);
        $(this)
          .closest(".product-single__add-one")
          .find(".add-one__prices-compare-at__money")
          .html(newComparePrice);
        $(this)
          .closest(".product-single__add-one")
          .find(".add-one__prices-current")
          .attr("data-variant-id", newVariantId);
        $(this)
          .closest(".product-single__add-one")
          .find(".add-one__prices-compare-at__money")
          .attr("data-variant-id", newVariantId);
        $(this)
          .closest(".product-single__add-one")
          .find(".add-one__discount")
          .attr("data-variant-id", newVariantId);
        $(this)
          .closest(".product-single__add-one")
          .find(".add-one__discount")
          .html(newBadge);
        $(this)
          .closest(".product-single__add-one")
          .find(".add-one__popup-opener")
          .attr("data-product-id", productId);
      } else {
        var selectedBubble = $(this)
          .closest(".product-single__add-one")
          .find(".addone_color-option-out.active");
        var newVariantId = selectedBubble.attr("data-variant-id");
        var newImage = $(
          '.pa_label_variant__js[data-id="' + newVariantId + '"]',
        ).attr("data-src");
        var newPrice = $(
          '.pa_label_variant__js[data-id="' + newVariantId + '"]',
        ).attr("data-price");
        var newComparePrice = $(
          '.pa_label_variant__js[data-id="' + newVariantId + '"]',
        ).attr("data-compare-price");
        var newBadge = $(
          '.pa_label_variant__js[data-id="' + newVariantId + '"]',
        ).attr("data-discount");
  
        var mmqBlock = selectedBubble.attr("data-mmq-block");
        var mmqCode = selectedBubble.attr("data-mmq-code");
  
        $(this)
          .closest(".product-single__add-one")
          .find(".addOneMainInput__js")
          .attr("data-mmq-block", mmqBlock);
        $(this)
          .closest(".product-single__add-one")
          .find(".addOneMainInput__js")
          .attr("data-mmq-code", mmqCode);
        $(this)
          .closest(".product-single__add-one")
          .find(".addOneMainInput__js")
          .attr("data-id", newVariantId);
        $(this)
          .closest(".product-single__add-one")
          .find(".add-one__image img")
          .attr("src", newImage);
        $(this)
          .closest(".product-single__add-one")
          .find(".add-one__prices-current")
          .html(newPrice);
        $(this)
          .closest(".product-single__add-one")
          .find(".add-one__prices-compare-at__money")
          .html(newComparePrice);
        $(this)
          .closest(".product-single__add-one")
          .find(".add-one__prices-current")
          .attr("data-variant-id", newVariantId);
        $(this)
          .closest(".product-single__add-one")
          .find(".add-one__prices-compare-at__money")
          .attr("data-variant-id", newVariantId);
        $(this)
          .closest(".product-single__add-one")
          .find(".add-one__discount")
          .attr("data-variant-id", newVariantId);
        $(this)
          .closest(".product-single__add-one")
          .find(".add-one__discount")
          .html(newBadge);
        $(this)
          .closest(".product-single__add-one")
          .find(".add-one__popup-opener")
          .attr("data-product-id", productId);
      }
  
      $(this)
        .closest(".product-single__add-one")
        .find(".addOneMainInput__js")
        .prop("checked", true);
      $(this)
        .closest(".product-single__add-one")
        .find(".addOneMainInput__js")
        .trigger("change");
    });
  
    $(".addone_color-option-out").click(function () {
      if ($(this).hasClass("disabled")) {
        return;
      }
      $(this)
        .closest(".product-single__add-one")
        .find(".addone_color-option-out")
        .removeClass("active");
      $(this).addClass("active");
  
      var selectedBubble = $(this)
        .closest(".product-single__add-one")
        .find(".addone_color-option-out.active");
      var newVariantId = selectedBubble.attr("data-variant-id");
      var newImage = $(
        '.pa_label_variant__js[data-id="' + newVariantId + '"]',
      ).attr("data-src");
      var newPrice = selectedBubble.attr("data-variant-price");
      var newComparePrice = selectedBubble.attr("data-variant-compare-price");
      var newBadge = $(
        '.pa_label_variant__js[data-id="' + newVariantId + '"]',
      ).attr("data-discount");
      $(this)
        .closest(".product-single__add-one")
        .find(".add-one__image img")
        .attr("src", newImage);
      $(this)
        .closest(".product-single__add-one")
        .find(".add-one__prices-current")
        .html(newPrice);
      $(this)
        .closest(".product-single__add-one")
        .find(".add-one__prices-compare-at__money")
        .html(newComparePrice);
  
      $(this)
        .closest(".product-single__add-one")
        .find(".add-one__prices-current")
        .attr("data-variant-id", newVariantId);
      $(this)
        .closest(".product-single__add-one")
        .find(".add-one__prices-compare-at__money")
        .attr("data-variant-id", newVariantId);
      $(this)
        .closest(".product-single__add-one")
        .find(".add-one__discount")
        .attr("data-variant-id", newVariantId);
      $(this)
        .closest(".product-single__add-one")
        .find(".add-one__discount")
        .html(newBadge);
  
      var mmqBlock = selectedBubble.attr("data-mmq-block");
      var mmqCode = selectedBubble.attr("data-mmq-code");
  
      $(this)
        .closest(".product-single__add-one")
        .find(".addOneMainInput__js")
        .attr("data-mmq-block", mmqBlock);
      $(this)
        .closest(".product-single__add-one")
        .find(".addOneMainInput__js")
        .attr("data-mmq-code", mmqCode);
      $(this)
        .closest(".product-single__add-one")
        .find(".addOneMainInput__js")
        .attr("data-id", newVariantId);
  
      if (window.clickedFromPopupColor == false) {
        $(this)
          .closest(".product-single__add-one")
          .find(".addOneMainInput__js")
          .prop("checked", true);
        $(this)
          .closest(".product-single__add-one")
          .find(".addOneMainInput__js")
          .trigger("change");
      }
    });
  });

  $('.desk_quantity-selector-adjust').on('click', function () {
    var $selector = $(this).closest('buy-quantity-selector');
    var $value = $selector.find('.desk_quantity-selector-value');
    var current = parseInt($value.text()) || 1;
    var action = $(this).attr('data');
    if (action === 'plus') {
      $value.text(current + 1);
    } else if (action === 'minus' && current > 1) {
      $value.text(current - 1);
    }
    var newValue = parseInt($value.text()) || 1;
    $selector
      .find('.desk_quantity-selector-adjust[data="minus"]')
      .toggleClass('disabledAdjust', newValue <= 1);
    if (window.updateTotalPrice) window.updateTotalPrice();
  });

  function deskSyncStickyQty() {
    var $main = $('buy-quantity-selector').first().find('.desk_quantity-selector-value');
    var $sticky = $('.desk_sticky-atc__qty-value');
    if (!$main.length || !$sticky.length) return;
    var value = parseInt($main.text(), 10) || 1;
    $sticky.text(value);
    $('.desk_sticky-atc__qty-adjust[data="minus"]').toggleClass('disabledAdjust', value <= 1);
  }

  $(document).on('click', '.desk_sticky-atc__qty-adjust', function () {
    var action = $(this).attr('data');
    $('buy-quantity-selector')
      .first()
      .find('.desk_quantity-selector-adjust[data="' + action + '"]')
      .first()
      .trigger('click');
    deskSyncStickyQty();
  });

  $(document).on('click', '.desk_quantity-selector-adjust', deskSyncStickyQty);
  $(deskSyncStickyQty);

  function parsePriceVal(text) {
    var s = text.trim().replace(/[^0-9.,]/g, '');
    var lastComma = s.lastIndexOf(',');
    var lastDot = s.lastIndexOf('.');
    if (lastComma > lastDot) {
      var afterComma = s.substring(lastComma + 1);
      if (afterComma.length === 2) {
        s = s.replace(/\./g, '').replace(',', '.');
      } else {
        s = s.replace(/,/g, '');
      }
    } else {
      s = s.replace(/,/g, '');
    }
    return parseFloat(s) || 0;
  }

  window.updateTotalPrice = function () {
    var $btn = $('.desk_atc-main-button');
    var singleCopy = $btn.attr('data-atc-single') || 'Add to cart';
    var multipleCopy = $btn.attr('data-atc-multiple') || 'Add {count} items to cart';

    var itemCount = 1;
    itemCount += $('top-addon-card.activated:not(.disabledAddon)').length;
    $('addon-chair-card.activated').each(function () {
      itemCount += 1;
      if ($(this).find('.ac_upsell-box.activated').length) {
        itemCount += 1;
      }
    });

    var copy = itemCount > 1
      ? multipleCopy.replace('{count}', itemCount)
      : singleCopy;

    $('.desk_atc-main-button-inner span:first-child').text(copy);
  };

  $(document).on('change', '.addOneMainInput__js', function () {
    setTimeout(window.updateTotalPrice, 50);
  });

  function deskInViewport($el) {
    if (!$el.length) return false;
    var rect = $el[0].getBoundingClientRect();
    return rect.top < $(window).height() && rect.bottom > 0;
  }

  function checkStickyAtcVisibility() {
    var $buyWrap = $('.desk_buy-button-wrap');
    if (!$buyWrap.length) return;
    var hide =
      deskInViewport($buyWrap) ||
      deskInViewport($('.desk_footer__section_outer.desk_footer-pp'));
    $('sticky-atc-button').toggleClass('notVisible', hide);
  }

  $(window).on('scroll', checkStickyAtcVisibility);
  checkStickyAtcVisibility();

  function applyTypeSelectorVisibility(selected) {
    $('[data-selector-id]').each(function () {
      var matches = $(this).attr('data-selector-id') === selected;
      $(this).toggleClass('hided', !matches);
    });
  }

  // Set initial visibility on load, based on whichever label already has .active
  // (server-rendered default is "standard" per the markup above).
  var $initialActive = $('.pdp_type-selector__label.active').first();
  if ($initialActive.length) {
    applyTypeSelectorVisibility($initialActive.attr('data'));
  }

  function deskScrollTypeSelectorToEdge($label) {
    if (!window.matchMedia('(max-width: 768px)').matches) return;

    var $scroller = $label.closest('type-selector');
    if (!$scroller.length) return;

    var el = $scroller[0];
    if (el.scrollWidth <= el.clientWidth) return;

    el.scrollTo({
      left: $label.index() === 0 ? 0 : el.scrollWidth,
      behavior: 'smooth',
    });
  }

  var deskGallerySlideTimer = null;

  function deskLockGallerySlide() {
    window.deskGallerySlideLocked = true;

    clearTimeout(deskGallerySlideTimer);
    deskGallerySlideTimer = setTimeout(function () {
      window.deskGallerySlideLocked = false;
    }, 2000);
  }

  function deskScrollB2bTableIntoView() {
    if (!window.matchMedia('(max-width: 768px)').matches) return;

    var $table = $('.desk_pdp-b2b-table-outer[data-selector-id="b2b"]').first();
    if (!$table.length || $table.hasClass('hided')) return;

    var $sticky = $('sticky-atc-button');
    var stickyHeight =
      $sticky.length && !$sticky.hasClass('notVisible') ? $sticky.outerHeight() : 0;

    var rect = $table[0].getBoundingClientRect();
    var alignBottom =
      rect.bottom + window.pageYOffset - window.innerHeight + stickyHeight + 16;
    var alignTop = rect.top + window.pageYOffset - 16;
    var top = Math.max(0, Math.min(alignBottom, alignTop));

    deskLockGallerySlide();

    if (window.lenis && typeof window.lenis.scrollTo === 'function') {
      window.lenis.scrollTo(top, { duration: 0.8 });
    } else {
      window.scrollTo({ top: top, behavior: 'smooth' });
    }
  }

  $('.pdp_type-selector__label').on('click', function () {
    $('.pdp_type-selector__label').removeClass('active');
    $(this).addClass('active');

    var selected = $(this).attr('data');
    applyTypeSelectorVisibility(selected);
    deskScrollTypeSelectorToEdge($(this));

    if (selected === 'b2b') deskScrollB2bTableIntoView();
  });

  $(function() {
  function positionB2bTooltip($trigger) {
    var $tooltip = $trigger.find('.desk_tooltip-box');
    if (!$tooltip.length) return;

    var wasVisible = $tooltip.is(':visible');
    if (!wasVisible) $tooltip.css('display', 'block');

    var width = $tooltip[0].offsetWidth;

    if (width && window.matchMedia('(max-width: 767px)').matches) {
      $tooltip.removeClass('tooltip-align-right');

      var triggerLeft = $trigger[0].getBoundingClientRect().left;
      var left = Math.max(16, window.innerWidth - 16 - width);

      $tooltip.css('left', left - triggerLeft + 'px');
    } else if (width) {
      $tooltip.css('left', '').removeClass('tooltip-align-right');

      var rect = $tooltip[0].getBoundingClientRect();
      var overflowsRight = rect.right > window.innerWidth - 8;

      $tooltip.toggleClass('tooltip-align-right', overflowsRight);
    }

    if (!wasVisible) $tooltip.css('display', '');
  }

  function checkTooltipOverflow() {
    $('.desk_pdp-b2b-table-tooltip__trigger').each(function() {
      positionB2bTooltip($(this));
    });
  }
  checkTooltipOverflow();

  $(document).on(
    'mouseenter touchstart',
    '.desk_pdp-b2b-table-tooltip__trigger',
    function() {
      positionB2bTooltip($(this));
    }
  );

  var _resizeTimer = null;
  $(window).on('resize', function() {
    clearTimeout(_resizeTimer);
    _resizeTimer = setTimeout(checkTooltipOverflow, 200);
  });
});